module.exports = __webpack_public_path__ + "static/media/Logo_MEXL_RVB_Orange.a6d13dc2.svg";